import { render } from "./ScalesPageTest.vue?vue&type=template&id=48da2f26"
import script from "./ScalesPageTest.vue?vue&type=script&lang=js"
export * from "./ScalesPageTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__